import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext, HttpStatusCode } from '@angular/common/http';
import { Observable } from 'rxjs';

import { DevicesPayload } from '../../../equipment/devices/components/devices.models';

import { SubscriptionCreationAPIBody, SubscriptionManagementResponse } from '../subscription-management.types';
import { LOADER_CONTEXT } from '../../../../services/interceptors/loader.interceptor';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionManagementApiService {
  private http = inject(HttpClient);

  getAll(tableState: DevicesPayload): Observable<SubscriptionManagementResponse> {
    return this.http.post<SubscriptionManagementResponse>(`/api/subscriptions`, tableState, {
      context: new HttpContext().set(LOADER_CONTEXT, true)
    });
  }

  createNewSubscription(payload: SubscriptionCreationAPIBody, subscriptionId: number): Observable<HttpStatusCode> {
    return this.http.post<HttpStatusCode>(`/api/subscriptions/${subscriptionId}`, payload);
  }

  updateSubscription(payload: SubscriptionCreationAPIBody, subscriptionId: number): Observable<HttpStatusCode> {
    return this.http.put<HttpStatusCode>(`/api/subscriptions/${subscriptionId}`, payload);
  }

  deleteSubscription(subscriptionId: number): Observable<HttpStatusCode> {
    return this.http.delete<HttpStatusCode>(`/api/subscriptions/${subscriptionId}`);
  }
}
